import { Injectable } from "@angular/core";
import {
	FormControl,
	FormArray,
	FormBuilder,
	FormGroup,
	Validators,
} from "@angular/forms";
import { Clipboard } from "@angular/cdk/clipboard";
import { MatSnackBar } from "@angular/material/snack-bar";
import { debounceTime } from "rxjs/operators";
const numericNumberReg = "^-?[0-9]\\d*(\\.\\d{1,2})?$";

@Injectable({
	providedIn: "root",
})
export class FormService {
	form: FormGroup;
	storageItems: any;
	displayRemoveIcon = false;

	constructor(
		private fb: FormBuilder,
		private clipboard: Clipboard,
		private _snackBar: MatSnackBar
	) {}

	createForm(): FormGroup {
		return this.fb.group({
			projectName: [""],
			basePrice: ["", Validators.pattern(numericNumberReg)],
			workDetails: this.fb.array([]),
			totalManday: [""],
			totalPrice: [""],
			totalPriceIncludeTax: [""],
		});
	}
	get workDetails(): FormArray {
		return this.form.get("workDetails") as FormArray;
	}
	createWorkDetailsForm(title?: string, manday?: number): FormGroup {
		return this.fb.group({
			title: [title],
			manday: [manday, Validators.pattern(numericNumberReg)],
		});
	}

	saveData(data) {
		this.storageItems = JSON.stringify(data);
		localStorage.storage = this.storageItems;
	}

	watchFormData() {
		//フォーム値の変更を監視
		this.form.valueChanges.pipe(debounceTime(300)).subscribe((v) => {
			const value = this.form.value;

			//ボタンチェック
			this.checkRemoveBtn();

			//工数合計
			value.totalManday = v.workDetails.reduce(
				(a, x) => a + +x.manday,
				0
			);
			//金額合計
			const mandayPrices = v.workDetails.map((item) => {
				return +item.manday * v.basePrice;
			});
			const totalPrice = mandayPrices.reduce((a, x) => a + x, 0);
			const totalPriceIncludeTax = totalPrice + totalPrice * 0.1;

			value.totalPrice = totalPrice.toLocaleString();
			value.totalPriceIncludeTax = totalPriceIncludeTax.toLocaleString();

			//保存
			this.saveData(value);
		});
	}

	checkRemoveBtn() {
		if (this.workDetails.length === 1) {
			this.displayRemoveIcon = false;
		} else {
			this.displayRemoveIcon = true;
		}
	}

	addWorkDetails() {
		this.workDetails.push(this.createWorkDetailsForm());
	}
	removeWorkDetails(index: number) {
		this.workDetails.removeAt(index);
	}

	clearform() {
		this.form.patchValue({
			projectName: "",
			basePrice: "",
			totalManday: 0,
			totalPrice: 0,
			totalPriceIncludeTax: 0,
		});
		this.workDetails.clear();
		this.addWorkDetails();
	}

	openSnackBar(message: string, action: string) {
		this._snackBar.open(message, action, {
			duration: 2000,
		});
	}

	copyToClipboard() {
		let worksContents = ``;
		this.form.value.workDetails.map((item, index) => {
			const price: number = this.form.value.basePrice * item.manday;
			const priceIncludeTax = (price + price * 0.1).toLocaleString();

			worksContents += `${index + 1}. ${
				item.title
			}：${priceIncludeTax}円（税込）
`;
		});

		const content: string =
			`案件名：${this.form.value.projectName}
概算見積価格：${this.form.value.totalPriceIncludeTax}円（税込）
作業日数：${this.form.value.totalManday}日程度

【内訳】
` + worksContents;

		this.clipboard.copy(content);

		this.openSnackBar("入力内容をコピーしました 😎", "close");
	}
}
